/**
 * All scheduled hangouts across entities the current user can see — the
 * flat list that backs the calendar view. Powers HangoutCalendar.jsx.
 *
 *   const { items, loading, refresh } = useScheduledHangouts();
 */

import { useState, useEffect, useCallback } from 'react';
import { useApi } from './use_api';
import { useAuth } from '../context/AuthContext';

export function useScheduledHangouts() {
    const api = useApi();
    const { user } = useAuth();
    const userId = user?.id;

    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    const load = useCallback(() => {
        if (!userId) { setLoading(false); return; }
        setLoading(true);
        api.get('/api/hangouts/scheduled', { params: { user_id: userId } })
            .then(data => setItems(Array.isArray(data) ? data : []))
            .catch(() => setItems([]))
            .finally(() => setLoading(false));
    }, [api, userId]);

    useEffect(() => { load(); }, [load]);

    return { items, loading, refresh: load };
}

export default useScheduledHangouts;
